module.exports = __webpack_public_path__ + "static/media/header-image-mobile.e3e1142b.jpg";